import React from 'react';
import { useIntl } from 'react-intl-next';
import { IconButton } from '@atlaskit/button/new';
import EditorCloseIcon from '@atlaskit/icon/core/migration/close--editor-close';
import EditIcon from '@atlaskit/icon/core/migration/edit';
import EditorFeedbackIcon from '@atlaskit/icon/core/migration/feedback--editor-feedback';
import Modal from '@atlaskit/modal-dialog';
import { Box, Flex, Pressable, xcss } from '@atlaskit/primitives';
import { messages } from './messages';
var FeedbackOptionsModalWrapperStyles = xcss({
  display: 'flex',
  flexDirection: 'column',
  padding: 'space.300'
});
var FeedbackOptionsModalHeaderStyles = xcss({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: 'space.250'
});
var FeedbackOptionsModalHeaderTextStyles = xcss({
  font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
var FeedbackOptionsWrapperStyles = xcss({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 'space.200'
});
var FeedbackOptionStyles = xcss({
  borderRadius: '3px',
  width: '100%',
  height: '56px',
  backgroundColor: 'color.background.neutral.subtle',
  ':hover': {
    backgroundColor: 'color.background.neutral.subtle.hovered'
  }
});
var FeedbackOptionIconWrapperStyles = xcss({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '2px',
  height: '32px',
  width: '32px'
});
var FeedbackOptionTextStyles = xcss({
  font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: 'color.text'
});
var FeedbackOptionSubTextStyles = xcss({
  font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
  color: 'color.text.subtlest'
});
export var FeedbackOptionsModal = function FeedbackOptionsModal(_ref) {
  var setShowFeedbackOptionsModal = _ref.setShowFeedbackOptionsModal,
    setShowEditDefinitionModal = _ref.setShowEditDefinitionModal,
    setShowFeedbackModal = _ref.setShowFeedbackModal,
    editDefinitionEnabled = _ref.editDefinitionEnabled;
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(Modal, {
    shouldReturnFocus: false
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: FeedbackOptionsModalWrapperStyles
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: FeedbackOptionsModalHeaderStyles
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: FeedbackOptionsModalHeaderTextStyles
  }, formatMessage(editDefinitionEnabled ? messages.definition_footer_feedback_options_modal_header : messages.definition_footer_feedback_options_modal_header_feedback_only)), /*#__PURE__*/React.createElement(IconButton, {
    appearance: "subtle",
    onClick: function onClick() {
      return setShowFeedbackOptionsModal(false);
    },
    label: "close-feedback-options-modal",
    icon: EditorCloseIcon
  })), /*#__PURE__*/React.createElement(Box, {
    xcss: FeedbackOptionsWrapperStyles
  }, editDefinitionEnabled && /*#__PURE__*/React.createElement(Pressable, {
    xcss: FeedbackOptionStyles,
    onClick: function onClick() {
      setShowFeedbackOptionsModal(false);
      setShowEditDefinitionModal(true);
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: "space.100"
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "color.background.accent.blue.subtle",
    xcss: FeedbackOptionIconWrapperStyles
  }, /*#__PURE__*/React.createElement(EditIcon, {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: "",
    color: "var(--ds-icon-inverse, #FFFFFF)"
  })), /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    gap: "space.025",
    alignItems: "start"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: FeedbackOptionTextStyles
  }, formatMessage(messages.definition_footer_feedback_options_edit_definition_option)), /*#__PURE__*/React.createElement(Box, {
    xcss: FeedbackOptionSubTextStyles
  }, formatMessage(messages.definition_footer_feedback_options_edit_definition_option_subtext))))), /*#__PURE__*/React.createElement(Pressable, {
    xcss: FeedbackOptionStyles,
    onClick: function onClick() {
      setShowFeedbackOptionsModal(false);
      setShowFeedbackModal(true);
    }
  }, /*#__PURE__*/React.createElement(Flex, {
    gap: "space.100"
  }, /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "color.background.accent.blue.subtle",
    xcss: FeedbackOptionIconWrapperStyles
  }, /*#__PURE__*/React.createElement(EditorFeedbackIcon, {
    LEGACY_size: "medium",
    spacing: "spacious",
    label: "",
    color: "var(--ds-icon-inverse, #FFFFFF)"
  })), /*#__PURE__*/React.createElement(Flex, {
    direction: "column",
    gap: "space.025",
    alignItems: "start"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: FeedbackOptionTextStyles
  }, formatMessage(messages.definition_footer_feedback_options_leave_feedback_option)), /*#__PURE__*/React.createElement(Box, {
    xcss: FeedbackOptionSubTextStyles
  }, formatMessage(messages.definition_footer_feedback_options_leave_feedback_option_subtext))))))));
};